"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailTransactionDynamoMapper = void 0;
const dynamodb_mapper_1 = require("../dynamodb-mapper");
const email_transaction_json_1 = require("./email-transaction-json");
exports.EmailTransactionDynamoMapper = (0, dynamodb_mapper_1.createDynamoMapper)('EmailTransaction', email_transaction_json_1.EmailTransactionJsonMapper);
